import React , { useCallback } from "react";
import { RouterPaths } from "../../../../app/appConstants";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import appHistory from "../../../../app/appHistory";
import ProfileInfoCard from "../../../../components/ProfileInfoCard/ProfileInfoCard";

interface IProfileVerifyAlertProps {
    show: boolean,
    handleVerifyButtonClick?: () => void,
}

export const ProfileVerifyAlert = ({handleVerifyButtonClick, show}: IProfileVerifyAlertProps) => {
    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent({module: 'Header'});

    const handleButtonClick = useCallback(() => {
        appHistory.push(RouterPaths.verify);
        handleGTMClick({button: 'Verify'});
    }, [handleGTMClick]);

    return show ? <ProfileInfoCard
       textIcon="IcCheckMarkShield"
       title={getLangPath('verify.title')}
       text={getLangPath('deposit.verify_identity')}
       btnText={getLangPath('deposit.verify_button')}
       btnIcon="IcArrowRight"
       onClick={handleVerifyButtonClick || handleButtonClick}
    /> : null;
};